"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _localizedFormat = _interopRequireDefault(require("dayjs/plugin/localizedFormat"));

var _advancedFormat = _interopRequireDefault(require("dayjs/plugin/advancedFormat"));

require("dayjs/locale/en-gb");

require("dayjs/locale/fr");

require("dayjs/locale/de");

require("dayjs/locale/es");

require("dayjs/locale/it");

require("dayjs/locale/nl");

require("dayjs/locale/pt");

require("dayjs/locale/zh-cn");

var _lodashEs = require("lodash-es");

var _intl = require("@ha/intl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_dayjs["default"].extend(_localizedFormat["default"]);

_dayjs["default"].extend(_advancedFormat["default"]);

var formatDate = function formatDate(locale, format, isoDate) {
  if (locale === void 0) {
    locale = _intl.Locale.en;
  }

  return (0, _dayjs["default"])(isoDate).locale(locale).format(format);
};

var _default = (0, _lodashEs.curry)(formatDate, 2);

exports["default"] = _default;